import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Button from '../../components/ui/Button';
import ProviderCard from './components/ProviderCard';
import SummaryMetrics from './components/SummaryMetrics';
import AddProviderModal from './components/AddProviderModal';
import DeleteConfirmationModal from './components/DeleteConfirmationModal';
import SearchAndFilter from './components/SearchAndFilter';
import Icon from '../../components/AppIcon';
import api from 'utils/api';
import { useProviderStore } from 'Store/ProviderStore';
import Loading from 'components/ui/Loading';

const ProviderDashboard = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const provider = useProviderStore((state) => state.provider);
  const updateFields = useProviderStore((state) => state.updateFields);

  // Mock data for providers
  const [providers, setProviders] = useState([]);

  const fetchProviders = async () => {
    setLoading(true);
    try {
      const res = await api.get('/providers');
      setProviders(res.data);
      localStorage.setItem('@providers', JSON.stringify(res.data));
      console.log(res.data);
    } catch (err) {
      console.error('Error fetching providers:', err);
      alert('خطا در دریافت اطلاعات خدمات دهنده‌ها');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProviders();
  }, []);

  const handleDelete = (provider) => {
    // Refresh list or remove provider from state
    setProviders((prev) => prev.filter((p) => p._id !== provider._id));
  };

  // Summary metrics
  const summaryMetrics = {
    totalProviders: providers?.length,
    totalEmployees: providers?.reduce(
      (sum, provider) => sum + provider?.employeeCount,
      0
    ),
    totalServices: providers?.reduce(
      (sum, provider) => sum + provider?.serviceCount,
      0
    ),
    todayAppointments: providers?.reduce(
      (sum, provider) => sum + provider?.todayAppointments,
      0
    ),
  };

  // Filter vs based on search and filter
  useEffect(() => {
    let filtered = providers;

    // Apply search filter
    if (searchTerm) {
      filtered = filtered?.filter(
        (provider) =>
          provider?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
          provider?.address?.toLowerCase()?.includes(searchTerm?.toLowerCase())
      );
    }

    // Apply status filter
    if (activeFilter !== 'all') {
      filtered = filtered?.filter(
        (provider) => provider?.status === activeFilter
      );
    }

    setFilteredProviders(filtered);
  }, [providers, searchTerm, activeFilter]);

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  const handleAddProvider = async (newProviderData) => {
    console.log('before save', newProviderData);
    try {
      const res = await api.post('/providers', newProviderData);
      const newProvider = res.data;
      console.log(newProvider);
      // Optional: add computed props for UI
      setProviders((prev) => [
        ...prev,
        {
          ...newProvider,
          status: 'active',
          employeeCount: 0,
          serviceCount: 0,
          todayAppointments: 0,
        },
      ]);
    } catch (err) {
      console.error('Error creating Provider :', err);
      alert('خطا در ایجاد خدمات دهنده');
    }
  };

  const handleEditProvider = (provider) => {
    //store in zustand
    updateFields({
      _id: provider._id,
      name: provider.name,
    });
    console.log('provider detailsss', provider);
    navigate('/provider-management', { state: { selectedProvider: provider } });
  };

  const handleDeleteProvider = async (provider) => {
    try {
      const res = await api.delete(`/providers/${provider._id}`);
    } catch (err) {
      console.error('Error creating Provider :', err);
      alert('خطا در حذف خدمات دهنده');
    }
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = (provider) => {
    setProviders((prev) => prev?.filter((s) => s?.id !== provider?.id));
    setSelectedProvider(null);
  };

  const handleViewDetails = (provider) => {
    navigate('/provider-management', { state: { selectedProvider: provider } });
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleFilter = (filter) => {
    setActiveFilter(filter);
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Sidebar isOpen={sidebarOpen} onClose={handleCloseSidebar} />
      {/* <Header
        isCollapsed={!sidebarOpen}
        onToggleSidebar={handleToggleSidebar}
      /> */}
      <main className="lg:mr-60 pt-16">
        <div className="p-6">
          {/* Page Header */}
          <div className="mb-6">
            <BreadcrumbNavigation />
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-4">
              <div>
                <h1 className="text-2xl font-bold text-foreground">
                  داشبورد خدمات دهنده‌ها
                </h1>
                <p className="text-muted-foreground mt-1">
                  مدیریت و نظارت بر تمام خدمات دهنده‌های شما
                </p>
              </div>
              <Button
                //   disabled
                variant="default"
                onClick={() => setShowAddModal(true)}
                iconName="Plus"
                iconPosition="right"
                className="w-full sm:w-auto">
                افزودن خدمات دهنده جدید
              </Button>
            </div>
          </div>

          {/* Summary Metrics */}
          <SummaryMetrics metrics={summaryMetrics} />

          {/* Search and Filter */}
          {/* <SearchAndFilter
            onSearch={handleSearch}
            onFilter={handleFilter}
            totalCount={provider?.length}
          /> */}

          {/* provider Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProviders?.map((provider) => (
              <ProviderCard
                key={provider?.id}
                provider={provider}
                onEdit={handleEditProvider}
                onDelete={handleDelete}
                onViewDetails={handleViewDetails}
              />
            ))}
          </div>
          {loading && <Loading />}
          {/* Empty State */}
          {filteredProviders?.length === 0 && (
            <div className="text-center py-12">
              <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon
                  name="Store"
                  size={32}
                  className="text-muted-foreground"
                />
              </div>
              <h3 className="text-lg font-medium text-foreground mb-2">
                {searchTerm || activeFilter !== 'all'
                  ? 'خدمات دهندهی یافت نشد'
                  : 'هنوز خدمات دهنده ای اضافه نکرده‌اید'}
              </h3>
              <p className="text-muted-foreground mb-6">
                {searchTerm || activeFilter !== 'all'
                  ? 'لطفاً جستجو یا فیلتر خود را تغییر دهید'
                  : 'اولین خدمات دهنده خود را اضافه کنید تا شروع کنید'}
              </p>
              {!searchTerm && activeFilter === 'all' && (
                <Button
                  //disabled
                  variant="default"
                  onClick={() => setShowAddModal(true)}
                  iconName="Plus"
                  iconPosition="right">
                  افزودن خدمات دهنده جدید
                </Button>
              )}
            </div>
          )}
        </div>
      </main>
      {/* Modals */}
      <AddProviderModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSave={handleAddProvider}
        ownerId={'66e78c12fa3a5f4bcd92ab11'}
      />
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        provider={selectedProvider}
      />
    </div>
  );
};

export default ProviderDashboard;
